<template>
    <div v-if="$state.lite">
        <graficos-parlamento/>
        <p>GRAFICO_BARRAS_VERTICAIS</p>
        <eleicoes-estatisticas-globais/>
        <eleicoes-estatisticas-invalidos/>
    </div>
    <div v-else-if="tab">
        <h1>Eleições Autárquicas {{$state.ano}}</h1>
        <triggers v-if="tabs && tabs.length > 1" :items="tabs" :value="active.tab" @select="selectTab"/>
        <h3 v-if="subtitle">{{subtitle}}</h3>
        <h2>{{tab.title}}</h2>
        <main>
            <section>
                <mapa v-if="tab.code == 'resultados'"/>
            </section>
            <section v-if="tab.code == 'resultados'">
                <triggers :items="regions" :value="active.regiao" @select="selectRegion"/>
                <eleicoes-resultados/>
                <p v-if="$state.comparar">COMPARACAO ({{$state.comparar}})</p>
            </section>
            <section v-else-if="tab.code == 'candidatos'"><p>CANDIDATOS</p></section>
            <section v-else-if="tab.code == 'noticias'"><p>NOTICIAS</p></section>
            <section v-else-if="tab.code == 'sondagens'"><p>SONDAGENS</p></section>
        </main>
    </div>
</template>

<script>
import { locals } from '@/core/map'
import { tipo } from '@/widgets/mapa/utils'

export default {
    data: () => ({
        tabs: [
            { code: 'resultados', title: 'Resultados' }
        ],
        optional: [
            { code: 'candidatos', title: 'Candidatos' },
            { code: 'noticias', title: 'Notícias' },
            { code: 'sondagens', title: 'Sondagens' }
        ],
        regions: [
            { code: 'CM', title: 'Câmara Municipal' },
            { code: 'AM', title: 'Assembleia Municipal' },
            { code: 'AF', title: 'Assembleia de Freguesias' }
        ]
    }),
    beforeMount() {
        this.$state.tab = this.tabs[0].code;
        if(!this.$state.local) this.$state.local = (!this.$state.lite ? this.$query.local : null) || '500000';
        if(!this.$state.regiao) this.$state.regiao = this.$query.regiao || 'CM';
        this.optional.forEach(tab => (this.$state[tab.code] && this.tabs.push(tab)));
    },
    methods: {
        selectRegion(region) {
            if(!region || !region.code) return;
            this.$state.regiao = region.code;
        },
        selectTab(tab) {
            if(!tab || !tab.code) return;
            this.$state.tab = tab.code;
        }
    },
    computed: {
        active() {
            let res = {}, active = {
                regions: 'regiao',
                tabs: 'tab'
            };
            for(let key in active) this[key].forEach((item, index) => (item.code == this.$state[active[key]] && (res[active[key]] = index)));
            return res;
        },
        title() {
            if(!this.$state.local && !this.$state.data) return;
            return (!this.$state.data ? null : this.$state.data.nome_do_territorio) || (!locals || !locals[this.$state.local] ? null : locals[this.$state.local].title)
        },
        subtitle() {
            return tipo(this.$state.local)
        },
        tab() {
            if(this.tabs.length == 1) return this.tabs[0];
            let res;
            this.tabs.forEach(tab => {
                if(tab.code == this.$state.tab) res = tab;
            })
            return res;
        },
        region() {
            if(this.regions.length == 1) return this.regions[0];
            let res;
            this.regions.forEach(region => {
                if(region.code == this.$state.region) res = region;
            })
            return res;
        }
    },
    watch: {

/* 
analytics.pageview('ELECTIONS', `change-tab-results__${tab}`);
*/
    }
}
</script>